<template>
    <div class="filhantering-forhandsvisning colspan whole">
        <ModalContainerMediaPreview
            v-if="redigering"
            class="preview"
            @close="modalDolj()"
            :enable-modal="!file?.type?.startsWith('audio')"
            :show-modal="modalForevisa"
            :file-meta="{
                patient: redigering.patientUUID,
                id: redigering.fileId,
            }"
            :file="file"
            :tabId="tabId"
            :isGenerell="isGenerellFil"
        />
        <div class="footer">
            <div class="info">
                <span class="filnamn"> {{ metaData.ursprungligtFilnamn }}</span>
                <span>{{ metaData.filstorlek }} </span>
                <span>{{ metaData.filformat }} </span>
            </div>
            <span class="zoomicon" role="button" @click="modalVisa"></span>
        </div>
    </div>
</template>

<script>
    import { inject } from "vue";
    import { mapMutations, mapGetters } from "vuex";
    import ModalContainerMediaPreview from "@/components/generic/preview/media/ModalContainerMediaPreview.vue";

    export default {
        name: "FilhanteringForhandsvisning",

        components: {
            ModalContainerMediaPreview,
        },

        props: ["file", "url", "metaData", "showPreview", "tabId"],

        setup() {
            const isGenerellFil = inject("isGenerellFil");

            return { isGenerellFil };
        },

        computed: {
            ...mapGetters("filhantering", ["modalForevisa", "redigering"]),
        },

        methods: {
            ...mapMutations("filhantering", ["modalVisa", "modalDolj"]),
        },

        mounted() {
            if (this.showPreview) {
                this.modalVisa();
            }
        },
    };
</script>

<style lang="scss" scoped>
    .filhantering-forhandsvisning {
        display: grid;
        padding: 1rem;

        padding-bottom: 1rem;
        margin-bottom: 2rem;

        background-color: #f0f3f8;

        .preview {
            max-height: 20rem;
        }

        .footer {
            display: flex;
            justify-content: space-between;
            padding-top: 1rem;

            span {
                display: inline-block;
                margin-right: 0.5rem;
            }

            span.filnamn {
                margin-right: 3rem;
            }

            span.zoomicon {
                $side: 1rem;
                background-image: url("@/assets/external_link_menu.svg");
                background-repeat: no-repeat;
                width: $side;
                height: $side;

                background-size: cover;
                margin-right: 1rem;

                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>
